import React, { useState } from "react";
import { Panel } from "@/components/Panel";
import { ShieldCheck, Lock } from "lucide-react";
import BookCallDialog from "@/components/BookCallDialog";

export default function SsoTab() {
  const [callOpen, setCallOpen] = useState(false);
  return (
    <Panel title="// SINGLE SIGN-ON" testId="sso-tab">
      <div className="p-8 max-w-2xl">
        <div className="flex items-start gap-4 mb-6">
          <div className="w-10 h-10 border border-[#FFB000]/40 bg-[#FFB000]/10 flex items-center justify-center">
            <Lock className="w-5 h-5 text-[#FFB000]" />
          </div>
          <div>
            <h3 className="font-heading font-bold text-2xl mb-2">Enterprise SSO — Contact Sales</h3>
            <p className="text-sm text-zinc-400 leading-relaxed">
              DARA supports SAML 2.0, OpenID Connect and SCIM provisioning with Okta, Azure AD,
              Google Workspace and custom IdPs. SSO is activated per tenant on the Enterprise plan.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-3 mb-6">
          {["Okta", "Azure AD", "Google Workspace", "OneLogin", "SAML 2.0", "SCIM v2"].map(p => (
            <div key={p} className="border border-zinc-800 p-3 font-mono text-[11px] text-zinc-400 flex items-center gap-2">
              <ShieldCheck className="w-3.5 h-3.5 text-[#00E676]" /> {p}
            </div>
          ))}
        </div>

        <button
          data-testid="sso-contact-btn"
          onClick={() => setCallOpen(true)}
          className="bg-[#FFB000] text-black font-bold font-mono text-[11px] uppercase tracking-wider px-6 py-3 hover:bg-[#E59E00]"
        >
          Request SSO enablement
        </button>
      </div>
      <BookCallDialog open={callOpen} defaultInterest="sso" onClose={() => setCallOpen(false)} />
    </Panel>
  );
}
